import ShowNotification from 'src/ui-components/modals/ToastNotifcationNotiStack'
import { ToastNotificationVariant } from 'src/ui-components/util/Interfaces'

export const isValidSearchText = (text: string): boolean => {
  if (text.length < 2 || text.length > 14) {
    ShowNotification({
      message: 'interchangeSearchTextError',
      variant: ToastNotificationVariant.ERROR,
    })
    return false
  }

  const wildcardPattern = /(\*|\?)/
  const multipleWildcardsAtEndPattern = /(\*|\?){2,}$/

  if (text.length < 4 && wildcardPattern.test(text)) {
    ShowNotification({
      message: 'wildCardSearchNotAllowedText',
      variant: ToastNotificationVariant.ERROR,
    })
    return false
  }

  if (text.length >= 4) {
    const prefix = text.slice(0, -1)

    if (
      wildcardPattern.test(prefix) ||
      multipleWildcardsAtEndPattern.test(text)
    ) {
      ShowNotification({
        message: 'invalidSearchPattern',
        variant: ToastNotificationVariant.ERROR,
      })
      return false
    }
  }

  return true
}
